import React, { useState } from "react";
import { Link } from "../../components";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/pro-light-svg-icons";
import {
  faFileExcel,
  faFileCsv,
  faFileCode,
} from "@fortawesome/pro-solid-svg-icons";
import { getDownloadSubmittedFile } from "../../services/outputFiles";
import * as fileSaver from "file-saver";
import { usDateFormat } from "../../utils";
import moment from "moment";
import AddToolTip from "../../components/AddToolTip";

const FILE_STATUSES = {
  1: "Creation InProgress",
  2: "Validation",
  3: "Generation Completed",
  0: "Error",
  4: "Upload Successful",
};

const FILE_FORMAT = {
  1: "IsCSV",
  2: "IsFixedLength",
  3: "IsExcel",
  4: "IsJSON",
  5: "IsXML",
  0: "IsNone",
};

function OutputFileTile({ data, plans }) {
  const [showToolTip, setshowToolTip] = useState(false);
  const planName = plans?.find((_) => _.rkPlanNumber == data?.rkPlanNumber)
    ?.name;
  const exportInputFile = (filename, storageLocation) => {
    var extension =
      filename?.split(".")?.pop() == "csv"
        ? "csv"
        : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
    getDownloadSubmittedFile(storageLocation)
      .then((response) => {
        var blob = new Blob([response], {
          type: extension,
        });
        fileSaver.saveAs(
          blob,
          filename.replace(
            filename.split(".").pop(),
            storageLocation.split(".").pop()
          )
        );
      })
      .catch((error) => {});
  };

  const getFileFormat = (fileExtension) => {
    switch (fileExtension) {
      case "csv":
        return 1;
      case "xlsx":
      case "xls":
        return 3;
      case "xml":
        return 5;
      case "json":
        return 4;
      case "txt":
        return 2;
      default:
        return 0;
    }
  };

  const fileFormat = getFileFormat(data?.fileName?.split(".")?.pop());

  const toolTip = () => {
    return (
      <div
        style={{
          textAlign: "center",
          position: "absolute",
          bottom: "10px",
          width: "150px",
          left: "5px",
        }}
      >
        <div style={{ marginLeft: "-50%" }} className="w-100">
          <div
            style={{
              backgroundColor: "black",
              color: "white",
              borderRadius: "5px",
              maxHeight: "130px",
              overflowY: "scroll",
            }}
            className="p-2 w-100"
          >
            {/* {PlanNames.map((item, ind) => {
              if (ind != 0) {
                return ( */}
            <div style={{ overflow: "hidden", textAlign: "left" }}>
              {planName}
            </div>
            {/* );
              }
            })} */}
          </div>
          <i class="fas fa-caret-down fa-2x" style={{ marginTop: "-20px" }}></i>
        </div>
      </div>
    );
  };

  return (
    // <Link
    //   to={`${MANAGE_MAPPER_ROUTES.OVERVIEW}/edit/${profileId}`}
    //   className="border rounded mr-3 p-3 mb-4 text-decoration-tile"
    //   style={{ display: "flex", marginTop: "5px", width: "100%" }}
    // >
    <div className="border rounded p-3 mt-4 mb-3 mr-2 ml-3">
      <div
        className="row mb-3 p-3"
        style={{
          borderBottom: "1px solid #ccc",
        }}
      >
        <div
          className="font-weight-bold mb-1 d-flex col-9 p-2"
          style={{ fontSize: "14px" }}
        >
          {fileFormat == 3 ? (
            <FontAwesomeIcon
              style={{ color: "green" }}
              icon={faFileExcel}
              size="lg"
            />
          ) : fileFormat == 5 ? (
            <FontAwesomeIcon
              style={{ color: "blue" }}
              icon={faFileCode}
              size="lg"
            />
          ) : (
            <FontAwesomeIcon
              style={{ color: "lightgreen" }}
              icon={faFileCsv}
              size="lg"
            />
          )}

          <div className="ml-2 W-90 d-flex">
            <AddToolTip
              name={data?.fileName}
              style={{ whiteSpace: "nowrap", fontSize: "14px" }}
            />
          </div>
        </div>

        <div className="col-2 p-2">
          {data?.outputFileStatus == 3 || data?.outputFileStatus == 4 ? (
            <div
              style={{
                background: "#5ACE9F40",
                color: "#3FAA7F",
                textAlign: "center",
              }}
              className="rounded p-1"
            >
              {FILE_STATUSES[data?.outputFileStatus]}
            </div>
          ) : (
            <div
              style={{
                background: "#FF9F9F40",
                color: "#EB4E3D",
                textAlign: "center",
              }}
              className="rounded p-1"
            >
              {FILE_STATUSES[data?.outputFileStatus]}
            </div>
          )}
        </div>
        <div className="col-1 p-2" style={{ textAlign: "right" }}>
          <Link>
            <FontAwesomeIcon
              className={`text-${
                data?.outputFileStatus == 3 ||
                data?.outputFileStatus == 4 ||
                (data?.outputFileStatus == 0 && data.storageLocation !== null)
                  ? "primary"
                  : "secondary"
              }`}
              icon={faDownload}
              style={{ marginTop: "10px" }}
              size="lg"
              color="#828282"
              onClick={
                data?.outputFileStatus == 3 ||
                data?.outputFileStatus == 4 ||
                (data?.outputFileStatus == 0 && data.storageLocation !== null)
                  ? () => exportInputFile(data.fileName, data.storageLocation)
                  : null
              }
            />
          </Link>
        </div>
      </div>

      <div className="row mt-3 p-3">
        <div className="col-2">
          <div
            style={{ fontSize: "14px", color: "grey", textDecoration: "none" }}
            className="mb-1"
          >
            Map
          </div>
          <div>
            <AddToolTip
              name={data?.profileName}
              style={{ whiteSpace: "nowrap", fontSize: "14px" }}
            />
          </div>
        </div>

        <div className="col-2">
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Map Type
          </div>
          {/* <div>{Description}</div> */}
          <div>
            {data?.triggeredEvent == "File Submit" ? "Pass Through" : "Output"}
          </div>
        </div>

        <div className="col-2">
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Plan Name
          </div>
          <div style={{ fontSize: "14px" }} className="d-flex">
            <AddToolTip name={planName} />
          </div>
        </div>

        <div className="col-2">
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Location
          </div>
          <div
            style={{ fontSize: "14px", overflow: "visible" }}
            className="d-flex"
          >
            <AddToolTip name={data?.storageLocation} />
          </div>
        </div>

        <div className="col-2">
          <div style={{ fontSize: "14px", color: "grey" }} className="mb-1">
            Time Stamp
          </div>
          <div
            style={{ fontSize: "14px", overflow: "visible" }}
            className="d-flex"
          >
            <div>
              {moment(new Date(data?.createdOn)).format("MM-DD-YYYY") +
                " " +
                moment(new Date(data?.createdOn)).format("HH:mm:ss")}
            </div>
          </div>
        </div>
      </div>
    </div>
    // </Link>
  );
}

export default OutputFileTile;
